module.exports = __webpack_public_path__ + "static/9be92fff.DetailNoPage.png";